<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/mis/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let status = {1:"未评估",2:"已评估"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(this.queryData);
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '用户账号', field: 'customer'},
            {click:"查询"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.appRiskCustomer.query, //请求路径和参数
          sequence: true,
          cols: [
            { title: '用户账号', field: 'customer'},
            { title: '平台', field: 'platform'},
            { title: '状态', field: 'status', render: (data, full) => {
                return status[data];
              }},
            { title: '创建时间', field: 'createTime', render: (data, full) => {
                return DateUtil.formatDate(data, "yyyy-MM-dd hh:mm:ss");
              }}
          ]
        }
      }
    }
  }
</script>
